export const EntityTypeConstants = {
    EntityTypeCustomer: "Customer",
    // #648: user-scoped settings — referenceId is the current profile's id.
    EntityTypeProfile: "Profile",
} as const;
